import React, { useState } from 'react';
import * as ReactDOMClient from 'react-dom/client';

import { Editor } from '@tinymce/tinymce-react';
import { tinymceKey } from '@/common/config/keys';

export default function PlatformCompletionEmail() {
    const [textareaValue, setTextareaValue] = useState(document.querySelector('#platformCompletionEmailText').innerHTML);
    const [ccAdmin, setCcAdmin] = useState(window.platformCompletionCcAdmin);

    const handleCcAdmin = (event) => {
        setCcAdmin(event.target.checked ? 1 : 0);
    };

    return (
        <>
            <blockquote id="platform-email-text">
                <p>Hi, <strong>[Name]</strong></p>
                <p>Congratulations on completing: <strong>[Mission Name]</strong>!</p>
                <br />
                <Editor 
                    textareaName='mission_completion_custom_text'
                    name='mission_completion_custom_text'
                    apiKey={tinymceKey}
                    value={textareaValue}
                    init={{
                        height: 240,
                        menubar: false,
                        statusbar: false,
                        paste_as_text: true,
                        paste_data_images: false,
                        paste_block_drop: true,
                        plugins: ['link', 'paste', 'template'],
                        toolbar: 
                        'undo redo | bold italic | \
                        | link | template',
                        remove_linebreaks: true,
                        forced_root_block: false,
                        template_preview_replace_values: {
                            first_name: 'Jack',
                            last_name: 'Black',
                            full_name: 'Jack Black',
                            completed_date: 'Jan 1st, 2021 - 2:03pm',
                            entry_question_answer: 'If you have specified a custom entry question, the participant\'s answer to this question will be displayed',
                        },
                        templates: [
                            {
                                title: 'First name',
                                description: '',
                                content: '<span>{$first_name}</span>'
                            },
                            {
                                title: 'Last name',
                                description: '',
                                content: '<span>{$last_name}</span>'
                            },
                            {
                                title: 'Full name',
                                description: '',
                                content: '<span>{$full_name}</span>'
                            },
                            {
                                title: 'Completed Date',
                                description: '',
                                content: '<span>{$completed_date}</span>'
                            },
                            {
                                title: 'Entry Question Answer',
                                description: '',
                                content: '<span>{$entry_question_answer}</span>'
                            }
                        ],
                    }}
                    onEditorChange={(value) => setTextareaValue(value)}
                />
                <br />
                <p>Thanks<br />
                <strong>[Mission Name]</strong> Admin</p>
            </blockquote>
            <div className="form-check">
                <input className="form-check-input" type="checkbox" value="1" id="mission_completion_cc_admin" name="mission_completion_cc_admin" checked={ccAdmin} onChange={handleCcAdmin} />
                <label className="form-check-label" htmlFor="mission_completion_cc_admin">
                    Send me a copy of this email when each user completes the mission
                </label>
            </div>
        </>
    );
}

const rctPlatformCompletionEmail = document.getElementById('rct-platform-completion-email');

if (rctPlatformCompletionEmail !== null) {
    ReactDOMClient.createRoot(rctPlatformCompletionEmail).render(<PlatformCompletionEmail />);
}